<template>
  <v-container fill-height @keyup.enter="() => valid ? onRegister() : ''">
    <v-row align="center" justify="center">
      <v-col md="6" xs="12"
        ><v-card>
          <v-row class="justify-center">
            <v-col md="8" xs="12">
              <v-card-title>Register</v-card-title>
              <v-form
                ref="form"
                v-model="valid"
              >
                <v-text-field 
                  outlined 
                  label="First Name" 
                  v-model="firstName" 
                  :rules="[
                    x => !!x || 'First Name is Required.'
                  ]"
                />
                <v-text-field 
                  outlined 
                  label="Last Name" 
                  v-model="lastName" 
                  :rules="[
                    x => !!x || 'Last Name is Required.'
                  ]"
                />
                <v-text-field 
                  outlined 
                  label="Email" 
                  type="email" 
                  v-model="email" 
                  :rules="[
                    x => !!x || 'Email is Required.',
                    x => /^.+@.+\..{2,}$/.test(x) || 'Please enter a valid email address.'
                  ]"
                />
                <v-text-field 
                  outlined 
                  label="Company (optional)" 
                  v-model="company" 
                />
                <v-text-field 
                  outlined 
                  label="Password"
                  hint="Password must be at least 6 characters long and contain at least one letter and one number."
                  persistent-hint 
                  type="password" 
                  v-model="password" 
                  :rules="[
                    x => !!x || 'Passsword is required.',
                    x => x.length > 5 || 'Password must be at least 6 characters long.',
                    x => /[0-9]/.test(x) || 'Password must contain at least one number.',
                    x => /[A-z]/.test(x) || 'Password must contain at least one letter.'
                  ]"
                />
                <v-text-field 
                  outlined 
                  label="Confirm Password" 
                  type="password" 
                  v-model="password2" 
                  :rules="[
                    () => !!password2 || 'Please confirm your password',
                    () => password === password2 || 'Password does not match.'
                  ]"
                />
              </v-form>
              <v-card-actions>
                <v-btn outlined class="gray" @click="() => $refs.form.reset()">Reset</v-btn>
                <v-spacer />
                <v-btn :disabled="!valid" :dark="false" class="green" @click="onRegister()">Register</v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="300">
      <v-card height="200" class="d-flex justify-center align-center" @click="dialog=false">
        This email address is currently is use.
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      password: "",
      password2: "",
      valid: false,
      dialog: false,
    };
  },
  methods: {
    async onRegister() {
      const result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "register",
        data: {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email.toLowerCase(),
          company: this.company,
          password: this.password,
        },
        headers: {
          "content-type": "application/json",
        },
      });

      if (result.data == "email exists") this.dialog = true;
      if (result.data == "account created") this.$router.push("newUser");
    },
  },
};
</script>

<style></style>